import { FC, ReactNode } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import LayoutBar from "../LayoutBar/LayoutBar";
import css from "./Layout.module.css";
import { useEffect, useState } from "react";
import { AlertProvider } from "../../context/AlertProvider";
import { DeepDiveToastProvider } from "../../context/DeepDiveToastProvider";
import { DeepDiveTrackingProvider } from "../../context/DeepDiveTrackingProvider";
import { PageTitleProvider } from "../../context/PageTitleContext";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const root = document.querySelector("html")!;
    root.classList.add("application");
    return () => {
      root.classList.remove("application");
    };
  });

  return (
    <AlertProvider>
      <DeepDiveTrackingProvider>
        <DeepDiveToastProvider>
          <PageTitleProvider>
            <Sidebar onCollapseChange={setIsSidebarCollapsed} />
            <div
              className={`${css.content} ${isSidebarCollapsed ? css.collapsed : ""}`}
            >
              <LayoutBar />
              {children ? children : <Outlet />}
            </div>
          </PageTitleProvider>
        </DeepDiveToastProvider>
      </DeepDiveTrackingProvider>
    </AlertProvider>
  );
};

export default Layout;
